import type { SearchResponse } from '@algolia/client-search';

import type { SearchAlgoliaHit } from 'modules/search/algolia/types/SearchAlgoliaHit';
import { SearchResultsHeaderCount } from 'modules/search/components/Results/Header/SearchResultsHeaderCount';
import { SaveSearchButton } from 'modules/search/components/SaveSearch/SaveSearchButton';
import type { SearchFacet } from 'modules/search/types/SearchFacet';

import {
  ViewJobPageSidebarResultsHeaderHolder,
  ViewJobPageSidebarResultsHeaderLeftSide,
  ViewJobPageSidebarResultsHeaderRightSide,
  ViewJobPageSidebarResultsHeaderWrapper,
} from './ViewJobPageSidebarResultsHeader.styled';

type Props = {
  results: SearchResponse<SearchAlgoliaHit> | undefined;
  isSearching: boolean;
  saveSearch: () => void;
  saveableSearch: boolean;
  searchFacets: SearchFacet[];
};

export function ViewJobPageSidebarResultsHeader({
  results,
  isSearching,
  saveSearch,
  saveableSearch,
  searchFacets,
}: Props) {
  return (
    <ViewJobPageSidebarResultsHeaderHolder>
      <ViewJobPageSidebarResultsHeaderWrapper>
        <ViewJobPageSidebarResultsHeaderLeftSide>
          <SearchResultsHeaderCount
            count={!isSearching ? results?.nbHits : undefined}
          />
        </ViewJobPageSidebarResultsHeaderLeftSide>
        <ViewJobPageSidebarResultsHeaderRightSide>
          {saveableSearch && (
            <SaveSearchButton
              saveSearch={saveSearch}
              searchFacets={searchFacets}
            />
          )}
        </ViewJobPageSidebarResultsHeaderRightSide>
      </ViewJobPageSidebarResultsHeaderWrapper>
    </ViewJobPageSidebarResultsHeaderHolder>
  );
}
